import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  padding: 16px 16px 0 76px;
  background-color: #fff;

  > div {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .vehicle-number {
    padding-right: 20px;
  }

  .search-vehicle {
    height: 35px;
  }

  .search-vehicle.root {
    margin-bottom: 0;
    height: 35px;
    fieldset {
      border: 1px solid #e4e4e4;
    }
    .start-icon img {
      min-width: 26px;
      max-width: 16px;
    }
  }

  .error {
    bottom: -16px;
  }

  .vehicle-search-container {
    padding-right: 20px;
  }
`;

export const CloseButtonContainer = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const DateContainer = styled.div`
  padding-right: 20px;

  input {
    max-width: 120px;
  }
`;
